import * as React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { createCustomers } from '../api';

const filter = createFilterOptions();

export default function Customerdetails({ cdetails, handleCustomerChange, invalue }) {
  const [value, setValue] = React.useState(invalue);
  const [open, toggleOpen] = React.useState(false);
  const handleChange = (id,name,number) => {
    if(id==-1){
      createCustomers({ name, phone: number })
        .then((response) => {
          console.log(response.data);
          setValue({
            id: response.data.id,
            name: response.data.name,
            phone: response.data.phone,
          });
          handleCustomerChange(response.data.id, response.data.name, response.data.phone);
        })
        .catch((error) => {
          alert('Failed to create customer');
          console.error('There was an error creating the customer!', error);
        });
    }else{
      handleCustomerChange(id, name, number);
    }
  };

  const handleClose = () => {
    setDialogValue({
      phone: '',
      name: '',
    });
    toggleOpen(false);
  };

  const [dialogValue, setDialogValue] = React.useState({
    phone: '',
    name: '',
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    setValue({
      phone: dialogValue.phone,
      name: dialogValue.name,
      id: -1
    });
    handleClose();
  };
  React.useEffect(() => {
    console.log(value)
    if(value){
      handleChange(value.id, value.name,value.phone)
    }
  }, [value]);

  return (
    <React.Fragment>
      <Autocomplete
        value={value}
        onChange={(event, newValue) => {
          if (typeof newValue === 'string') {
            // timeout to avoid instant validation of the dialog's form.
            setTimeout(() => {
              toggleOpen(true);
              setDialogValue({
                phone: newValue,
                name: '',
              });
            });
          } else if (newValue && newValue.inputValue) {
            toggleOpen(true);
            setDialogValue({
              phone: newValue.inputValue,
              name: '',
            });
          } else {
            setValue(newValue);
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          if (params.inputValue !== '') {
            filtered.push({
              inputValue: params.inputValue,
              phone: `Add "${params.inputValue}"`,
            });
          }

          return filtered;
        }}
        id="free-solo-dialog-demo"
        options={cdetails}
        getOptionLabel={(option) => {
          // for example value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option.phone;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              {option.phone}
            </li>
          );
        }}
        sx={{ width: 300 }}
        freeSolo
        renderInput={(params) => <TextField {...params} label="Customer Phone number" />}
      />
      <Dialog open={open} onClose={handleClose}>
        <form onSubmit={handleSubmit}>
          <DialogTitle>Add a new Customer</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              value={dialogValue.phone}
              onChange={(event) =>
                setDialogValue({
                  ...dialogValue,
                  phone: event.target.value,
                })
              }
              label="Phone No"
              type="number"
              variant="standard"
            />
            <TextField
              margin="dense"
              id="name"
              value={dialogValue.name}
              onChange={(event) =>
                setDialogValue({
                  ...dialogValue,
                  name: event.target.value,
                })
              }
              label="Name"
              type="text"
              variant="standard"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add</Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
